import { twMerge } from "tailwind-merge"

interface InfoFieldProps {
  label?: string
  value?: string | number | null
  className?: string
  fallbackText?: string
}

export default function InfoField({ 
  label,
  value, 
  className,
  fallbackText = 'N/A'
 }: InfoFieldProps) {
  const displayValue = (value === null || value === undefined || String(value).trim() === "") 
    ? fallbackText 
    : value;

  return (
    <div className={twMerge("flex flex-col gap-1 p-2 flex-1 bg-white-100 rounded ", className)}>
      {label && <span className="text-xs">{label}</span>}
      <p className="font-bold">{displayValue}</p>
    </div>
  )
}